import { useConfirmationModal } from '@customerio/pluma-components/react';

export const DISCARD_MESSAGE = 'Your unsaved changes to this app will be lost. This cannot be undone.';

/** Titled with the app's saved name when it has one; a create has nothing to name yet. */
export function useDiscardPrompt(): (appName?: string) => Promise<boolean> {
  const confirm = useConfirmationModal();

  return (appName) =>
    confirm({
      title: appName == null ? 'Discard changes?' : `Discard changes to ${appName}?`,
      message: DISCARD_MESSAGE,
      confirmLabel: 'Discard changes',
      cancelLabel: 'Cancel',
      isCritical: true,
    });
}
